exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider{margin-bottom:-3px}.slider,.slider__item{height:auto;width:100%}", ""]);

// exports
